"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
class Navbar {
    static init() {
        const nav = document.querySelector('.navbar-default');
        const heroImage = document.querySelector('section.hero.hero-bg-image-wrapper');
        if (!nav) {
            return;
        }
        if (heroImage) {
            nav.classList.add('transparent-bg');
        }
        if (document.querySelector('.top-nav') === null) {
            window.addEventListener('scroll', () => {
                if (window.scrollY == 0) {
                    nav.classList.remove('not-on-top');
                }
                else {
                    nav.classList.add('not-on-top');
                }
            });
        }
        if (!document.body.classList.contains('site-am-p')) {
            window.addEventListener('scroll', () => {
                if (window.scrollY >= 50) {
                    nav.classList.add('not-on-top');
                }
                else {
                    nav.classList.remove('not-on-top');
                }
            });
        }
    }
}
exports.Navbar = Navbar;
